<template>
    <div>
        <template v-if="income_tax_slabs === true">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left"> Income Tax Slabs </h1>
                <router-link to="/addIncomeTaxSlab" class="btn btn-primary active float-right"> Add Income Tax Slab</router-link>
            </div>
            <table id="incomeTaxSlabTable" class="table" width="100%">
                <thead>
                    <tr>
                        <th>No.</th>
                        <th>Min. Income</th>
                        <th>Max. Income</th>
                        <th>Fixed Tax</th>
                        <th>Percentage Exceeding Amount</th>
                        <th>Exceeding Amount</th>
                        <th class="text-center">Action</th>
                    </tr>
                </thead>
            </table>
        </template>
        <template v-else-if="income_tax_slabs === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="income_tax_slabs === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                data : null,
                pageView: null,
                income_tax_slabs: null
            };
        },
        methods: {
            callDataTable(){
                var that = this;
                var incomeTaxSlabTable = $('#incomeTaxSlabTable').DataTable({
                    "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    processing: true,
                    serverSide: true,
                    searching: true,
                    ajax: {
                        "url": "api/listIncomeTaxSlabs",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                    },
                    deferRender: true,
                    columns: [
                        {data: 'id'},
                        {data: 'min_income'},
                        {data: 'max_income'},
                        {data: 'fixed_tax'},
                        {data: 'percentage_amount_exceeding'},
                        {data: 'amount_exceeding'},
                        {data: 'id', sorting: false, render: function(data,type,full){
                            var $url = '/editIncomeTaxSlab/'+full['id'];
                            return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" class="action edit" ><i class="fas fa-pencil-alt"></i></a>';
                        }}
                    ],
                    "order": [[ 0, "desc" ]],
                    "columnDefs": [{
                            className: "text-center",
                            "targets": [ 6 ]
                        }],
                    "initComplete": () => {
                        this.$Progress.finish();
                    }
                });
            }
        },
        mounted() {
            this.$Progress.start();
			this.can('income_tax_slabs').then(result => {
                this.income_tax_slabs = result.income_tax_slabs;
            }).then(result => {
                if(this.income_tax_slabs == true){
					this.callDataTable();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });

        },
    }
</script>
